import type { CommunityDetail } from '@pba/react-network';
import { Avatar, Card, Col, DetailsCategoryItem, InformationLineIcon, Row } from 'ui';
import { images } from 'common/utils';
import { useGetCommunityPrivacyInformation } from './hooks';

type P = {
  community: CommunityDetail;
};

const CommunityDetailsCard = ({ community }: P) => {
  const privacyInformation = useGetCommunityPrivacyInformation({ privacy: community.privacy });

  return (
    <Card title={<Card.Title icon={<InformationLineIcon />}>Details</Card.Title>}>
      <Row gutter={[0, 'ms']}>
        <Col span={24}>
          <DetailsCategoryItem
            category="Organization"
            icon={
              <Avatar
                alt="Organization profile photo"
                fallbackPhoto={images.default.organizationProfilePhoto}
                photo={community.organization.profilePhoto?.url}
                size="large"
              />
            }
            name={community.organization.name}
          />
        </Col>
        <Col span={24}>
          <DetailsCategoryItem
            category="Privacy"
            description={privacyInformation.description}
            icon={privacyInformation.icon}
            name={privacyInformation.name}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default CommunityDetailsCard;
